import { totalRecordByDateConstants } from "../constant/totalRecord.constants";

export const initialState = {
    dataTotalRecordByDate: [],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const totalRecordByDateReducer = (state = initialState, action) => {
    switch (action.type) {
        case totalRecordByDateConstants.GET_SUCCESS:
            return {
                ...state,
                dataTotalRecordByDate: action.totalRecordByDateList,
                isLoading: true
            };
        case totalRecordByDateConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};

export default totalRecordByDateReducer;
